/**
 * The landing page's soft rotating orb, made small and CSS-only for the question screens: between
 * questions, progress is this orb filling by module, with no canvas. `fill` is 0..1. `still` stops the
 * spin and the breathing ("nothing loops on a question screen"); the fill still moves on a module change.
 */
export function AiOrb({ fill = 1, className = '', label, still = false }: { fill?: number; className?: string; label?: string; still?: boolean }) {
  const f = Math.max(0, Math.min(1, fill));
  return (
    <div
      className={`relative ${still ? 'lp-orb-still ' : ''}${className}`}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <div className="lp-orb absolute inset-0 rounded-full" style={{ opacity: 0.18 + 0.44 * f }} />
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: `conic-gradient(var(--indigo, #4f46e5) 0turn, var(--violet, #7c3aed) ${f}turn, transparent ${f}turn)`,
          WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 2.5px), #000 calc(100% - 2px))',
          mask: 'radial-gradient(farthest-side, transparent calc(100% - 2.5px), #000 calc(100% - 2px))',
          transition: 'background 600ms cubic-bezier(.16,1,.3,1)',
        }}
      />
      <div className="absolute inset-[18%] rounded-full border border-white/40" />
      <div className="lp-orb-core absolute inset-[30%] rounded-full" style={{ opacity: 0.35 + 0.65 * f }} />
    </div>
  );
}
